(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jrj-builder-chat"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.jrj-v2-builder__form, [data-jrj-mini-tune-builder], [data-jrj-tune-setup]';
    let cleanup = () => {};
    let pageActive = true;

    function initialize() {
      cleanup();
      cleanup = () => {};
      if (!pageActive || !window.IntersectionObserver || !window.MutationObserver || !window.matchMedia) return;

      const template = document.getElementById('jrj-builder-chat-template');
      const chat = document.querySelector('shopify-chat');
      const builders = Array.from(document.querySelectorAll(selector));
      if (!template || !chat || typeof chat.show !== 'function' || !builders.length) return;

      const mobile = window.matchMedia('(max-width: 749px)');
      const visible = new Set();
      const rows = [];
      const buttons = [];
      let lastButton = null;
      let wasOpen = chat.hasAttribute('open');

      function update() {
        const open = chat.hasAttribute('open');
        document.body.classList.toggle('jrj-builder-chat-active', mobile.matches && visible.size > 0 && !open);
        buttons.forEach((button) => button.setAttribute('aria-expanded', String(open)));
        if (wasOpen && !open && lastButton && lastButton.getClientRects().length) lastButton.focus();
        wasOpen = open;
      }

      builders.forEach((builder) => {
        const first = template.content.firstElementChild.cloneNode(true);
        const last = template.content.firstElementChild.cloneNode(true);
        [first, last].forEach((row) => {
          const button = row.querySelector('button');
          button.addEventListener('click', () => {
            lastButton = button;
            chat.show();
          });
          rows.push(row);
          buttons.push(button);
        });
        builder.prepend(first);
        builder.append(last);
      });

      const intersection = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        update();
      });
      builders.forEach((builder) => intersection.observe(builder));
      const state = new MutationObserver(update);
      state.observe(chat, { attributes: true, attributeFilter: ['open'] });
      mobile.addEventListener('change', update);
      update();

      cleanup = () => {
        intersection.disconnect();
        state.disconnect();
        mobile.removeEventListener('change', update);
        rows.forEach((row) => row.remove());
        document.body.classList.remove('jrj-builder-chat-active');
      };
    }

    function start() {
      if (!window.customElements) return;
      window.customElements.whenDefined('shopify-chat').then(initialize);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();

    document.addEventListener('shopify:section:load', start);
    document.addEventListener('shopify:section:unload', () => {
      cleanup();
      cleanup = () => {};
      window.setTimeout(start, 0);
    });
    window.addEventListener('pagehide', () => {
      pageActive = false;
      cleanup();
      cleanup = () => {};
    });
    window.addEventListener('pageshow', (event) => {
      pageActive = true;
      if (event.persisted) start();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jrj-cam-page-tabs"] && !Shopify.designMode) return;
  try {
    (()=>{function setup(root){root.querySelectorAll('[data-cgm-tabs]').forEach(group=>{if(group.dataset.ready)return;group.dataset.ready='true';const buttons=[...group.querySelectorAll('[role="tab"]')];const panels=buttons.map(b=>document.getElementById(b.getAttribute('aria-controls')));function select(i,focus=false){buttons.forEach((b,n)=>{b.setAttribute('aria-selected',n===i?'true':'false');b.tabIndex=n===i?0:-1;panels[n].hidden=n!==i});if(focus)buttons[i].focus()}buttons.forEach((b,i)=>{b.addEventListener('click',()=>select(i));b.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%buttons.length;else if(e.key==='ArrowLeft')n=(i+buttons.length-1)%buttons.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=buttons.length-1;else return;e.preventDefault();select(n,true)})});select(0)})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup(document));else setup(document);document.addEventListener('shopify:section:load',e=>setup(e.target))})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jrj-remote-builder-page"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded',function(){
  var requested=new URLSearchParams(window.location.search).get('tune');
  if(requested!=='base'&&requested!=='custom')return;
  document.querySelectorAll('.jrj-remote-builder-page [data-jrj-mini-type]').forEach(function(select){
    select.value=requested;
    select.dispatchEvent(new Event('change',{bubbles:true}));
  });
});
  } catch(e) { console.error(e); }
})();

})();
